module.exports = __webpack_public_path__ + "700bd717b5eb2855ff392efa9b3835ef.svg";